'use client';

import { CacheProvider } from '@chakra-ui/next-js';
import * as React from 'react';
import { getConfig } from '~config/getConfig';
import { BaseGlobalStyles } from '~ui/globalStyles/BaseGlobalStyles';
import { ConfigProvider } from './ConfigContext/ConfigProvider';
import { StorageProvider } from './StorageContext/StorageProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var conf = getConfig();
/**
 * Provider for root layout as there cannot be anything client-side.
 */

export var LayoutProviders = function LayoutProviders(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsxs(CacheProvider, {
    children: [/*#__PURE__*/_jsx(BaseGlobalStyles, {}), /*#__PURE__*/_jsx(ConfigProvider, {
      config: conf,
      children: /*#__PURE__*/_jsx(StorageProvider, {
        children: children
      })
    })]
  });
};